import { Fragment } from "react";

import { define } from "@/components/builder/utils";
import RootBackground from "@/components/builder/utils/RootBackground";

function PartialRootPreview({ children }) {
  return <RootBackground>
    {children}
  </RootBackground>
}

export default define('partial_root', PartialRootPreview, Fragment)
  .build()
